function updateLocalization({ country, rootUrl }) {
  const formId = crypto.randomUUID();
  const formHtml = `
    <form id="${formId}" action="/localization" method="POST" hidden>
      <input name="form_type" value="localization">
      <input name="utf8" value="true">
      <input name="_method" value="PUT">
      <input name="return_to" value="${rootUrl}">
    </form>
  `;
  document.body.insertAdjacentHTML("beforeend", formHtml);
  console.log(formHtml);
  document.getElementById(formId).submit();
}

document.addEventListener("DOMContentLoaded", function () {
  try {
    if (typeof Shopify !== "undefined" && Shopify.designMode) {
      // Azioni specifiche per la modalità design di Shopify
      console.log("Shopify Design Mode: No localization update.");
      return;
    }
    // Recupera l'URL corrente
    const location = window.location;
    const fullUrl = location.href;
    const origin = location.origin;
    const pathname = location.pathname;

    // Possibili valori di customerLocale
    const validLocales = ["us", "ca", "eu", "gb"];
    const fallbackLocale = "us";

    // Estrae il customerLocale dal DOM o usa il fallback
    const customerLocaleElement = document.querySelector("#customerLocale");
    let customerLocale = customerLocaleElement
      ? customerLocaleElement.textContent.trim().toLowerCase()
      : fallbackLocale;

    // Valida il valore di customerLocale
    if (!validLocales.includes(customerLocale)) {
      console.warn(
        `Invalid customerLocale: "${customerLocale}". Falling back to "${fallbackLocale}".`
      );
      customerLocale = fallbackLocale;
    }

    // Determina il langSub basato su customerLocale
    const customerLangSub =
      customerLocale == "us" ? "" : `/en-${customerLocale}`;

    // Estrai il langSub e urlPath dall'URL corrente
    let langSubMatch = pathname.match(/^\/en-[a-z]{2}/);
    let langSub = langSubMatch ? langSubMatch[0] : "";
    let urlPath = pathname.replace(langSub, "");

    // Costruisce l'URL di destinazione
    let destinationUrl;
    console.log("destinationUrl: ", destinationUrl);
    if (langSub === customerLangSub) {
      console.log(
        "Localization already matches the current URL. No redirection needed."
      );
      return; // Evita il ciclo infinito
    } else {
      destinationUrl = origin + customerLangSub + urlPath;
      console.log(`Redirecting to: ${destinationUrl}`);
      updateLocalization({
        country: customerLocale,
        rootUrl: destinationUrl,
      });
    }
  } catch (error) {
    console.error("Error in localization script:", error);
  }
});
